<template>
  <!-- 我要補導別人 （報名頁） -->
  <div class="page">
    <header class="wave-header">
      <a class="link back nav-back">
        <i class="material-icons">arrow_back</i>
      </a>
      <h2>文字學</h2>
    </header>
    <div class="page-content">
      <f7-list media-list>
        <f7-list-item title="陳小明" link="#" subtitle="電機學系 一年級" text="被當了三個學期還是不會" @click="openPrompt()">
          <img slot="media" class="list-avatar" src="https://randomuser.me/api/portraits/men/4.jpg" width="44" />
        </f7-list-item>
        <f7-list-item title="丁紹宏" link="#" subtitle="外國語文系 二年級" text="專題報告的部分有跨相關領域，想徵求專業大大教學" @click="openPrompt()">
          <img slot="media" class="list-avatar" src="https://randomuser.me/api/portraits/women/29.jpg" width="44" />
        </f7-list-item>
      </f7-list>
    </div>
  </div>
</template>

<script>
import Service from "../../../service";
import PopModalTest from "./PopModalTest";

export default {
    components: {},
    data() {
      return {
        dish: Service.getDish(this.$f7route.params.id),
        checked: true
      };
    },
    created: function () {
    },
    mounted() {
    },
    methods: {
      openPrompt:function () {
        this.$dialog.modal({
          component: PopModalTest,
          title: "陳小明",
          showCloseBtn: this.checked,          
          params:{firstInput:"被當了三個學期還是不會"},
          callback: p => {
            this.$dialog.alert("已進入媒合中", { type: "success", showIcon: false },);                        
          }
        });
      },
      checkHref: function (linkText) {
          this.$f7router.navigate( '/' + linkText);
      },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/teaching-counseling/teaching-step2.vue